import axios, { AxiosResponse } from 'axios';

import { EStavHl } from 'enums/akcionarKorpAkce/stavHl';
import { ETypUdalosti } from 'enums/akcionarKorpAkce/typUdalosti';

export interface IPrehled {
    id: number;
    isin: string;
    nazevemise: string;
    datumkonani: Date;
    rozhodnyden: Date;
    elhlasovani?: boolean;
    eltermin?: Date;
    stavhl?: EStavHl;
    typudalosti: ETypUdalosti;
    predano?: Date;
    potvrzeno?: Date;
}
export interface ISezudalosti {
    sezudalosti: IPrehled[];
}

export interface ISeznamNotifikaci {
    typ: 'ZELENE' | 'CERVENE' | 'ZLUTE';
    text: string;
}

const prehledApi = () => {
    return axios({
        method: 'GET',
        url: 'Akcionar/Prehled'
    }).then((resp: AxiosResponse<ISezudalosti>) => resp.data.sezudalosti);
};
export default prehledApi;
